import React from 'react'
import type { CompactLayoutContextType } from './types'
import { noop } from '../utils/fn'

export const CompactLayoutContext = React.createContext<CompactLayoutContextType>({
  layoutState: 'spacious',
  requestLayoutState: noop,
  unregisterLayoutState: noop,
})
